import LOCATIONS from "@/data/locations.yml";
import ContentBlock from "@/components/newsletter/blocks/ContentBlock";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  mixins: [dynamicLocalization],
  components: { ContentBlock },
  data() {
    return {
      LOCATIONS,
    };
  },
};
